export interface ChatFilters {
    firstUser: string
    secondUser: string
    topic: number
}

export interface GroupChatFilters {
    topic: number,
    user: string[]
}

export interface ChatDTO {
    id: number,
    firstUser: string,
    secondUser: string,
    isBroadcast: boolean,
    carbonCopy: string[],
    lastMessageDate: Date,
    topic: number,
    notSeenMessages: number,
    active: boolean
}

export interface GroupChatDTO {
    id: number
    users: string[]
    topic: string
    active: boolean
    lastMessageDate: Date
    notSeenMessages: number
}

export interface UserInfoDTO {
    name: string,
    surname: string,
    role: string,
    mail: string,
    avatarObjectId: string | null,
    userId: string,
    businessName?: string
}

export interface MessageDTO {
    id: number,
    timestamp: Date,
    message: string,
    sender: string
    businessName : string 
    name : string 
    surname: string
}

export interface MessageResponse {
    total: number
    page: number
    perPage: number
    prev: boolean
    next: boolean
    totalPage: number
    messages: MessageDTO[]
}

export interface TopicUnseenInfoDTO {
    topic: string
    unseen: number
    lastMessage: string
}

export interface MessageFilterDTO {
    page: number
    itemsPerPage: number
    order: boolean
}

export const chatRoleMap = new Map<string | undefined, string>([
    ['admins', 'Amministratore'],
    ['admin-accountants', 'Account'],
    ['accountants', 'Contabile'],
    ['financial-advisors', 'Commercialista'],
    ['operators', 'Collaboratore'],
    ['companies', 'Azienda']
])